module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraLight.8274189.eot";